import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/kitStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class KitStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

KitStrategy.title = actions.title
const option = {
  value: 'manage_kits',
  display: 'Manage Kits',
  category: 'kits_boms',
  Component: KitStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
KitStrategy.option = option
